import { type FC } from 'react'

import { useTranslation } from 'react-i18next'

import { IconStarGradient } from 'assets/svg/sprite'
import './_subscription-card.scss'

interface priceData {
  id: string
  discount: number | null
  price: number
  month_count: number
  name: string
}

export interface FormatSubscriptionTextProps {
  months?: number
  days?: number
  price: number
  month_count: number
  t: (key: string) => string
}

export const formatSubscriptionText = ({
  months,
  days,
}: FormatSubscriptionTextProps): JSX.Element => {
  const freePeriodText = [
    months ? `${months} month(s)` : null,
    days ? `${days} day(s)` : null,
  ]
    .filter(Boolean)
    .join(' and ')

  return (
    <>
      {freePeriodText && `${freePeriodText} free`}
    </>
  )
}

const formatPrice = (val: number) =>
  Number.isInteger(val) ? val.toString() : val.toFixed(2)

const SubscriptionCard: FC<{
  selected: boolean
  onClick: () => void
  data: priceData
  notInList?: boolean
  campaignDiscount?: number
  free?: any
  campaign?: any
}> = ({
  data,
  selected,
  onClick,
  notInList = false,
  campaignDiscount,
  campaign,
}) => {
  const { t } = useTranslation()

  const isFreePromo =
    campaign?.discounted_price != null &&
    Number(campaign.discounted_price) === 0

  const discountedPrice = campaignDiscount
    ? ((data.price / data.month_count) * campaignDiscount) / 100
    : null

  const price = discountedPrice
    ? data.price - discountedPrice
    : data.price

  return (
    <div
      onClick={onClick}
      className={`subscription-card-container ${
        selected ? 'subscription-card-container-selected' : ''
      }`}
    >
      <div className='subscription-card-selected-mark'></div>

      <div className='subscription-card-selected-star'>
        <IconStarGradient />
      </div>

      {!notInList && (
        <div className='subscrition-card-radio-outer'>
          <div className='subscrition-card-radio-inner'></div>
        </div>
      )}

      <div className='subscription-card-info-container'>
        <div className='subscrition-card-info-time'>
          <div className='subscrition-card-info-time-main'>
            {isFreePromo ? 'Free Trial' : data.name}
          </div>

          {!notInList &&
            (data.discount != null && data.discount > 0 ? (
              <div className='subscrition-card-info-time-discount'>
                {t('save')} {data.discount}%
              </div>
            ) : (
              campaignDiscount && (
                <div className='subscrition-card-info-time-discount'>
                  {t('save')} {campaignDiscount}%
                </div>
              )
            ))}
        </div>

        <div className='subscrition-card-info-price'>
          {!notInList ? (
            <>
              <div className='subscrition-card-info-price-main'>
                {isFreePromo ? '' : `$${formatPrice(price)}`}
              </div>

              <div className='subscrition-card-info-price-sub'>
                {!campaignDiscount && !isFreePromo
                  ? `$${formatPrice(
                      price / data.month_count
                    )} / ${t('monthShort')}`
                  : isFreePromo
                  ? formatSubscriptionText({
                      months: 0,
                      days: campaign?.duration,
                      price: data.price,
                      month_count: data.month_count,
                      t: (key) =>
                        key === 'monthShort' ? 'mo' : key,
                    })
                  : `First month $${formatPrice(
                      price
                    )}, then $${formatPrice(
                      data.price / data.month_count
                    )} / ${t('monthShort')}`}
              </div>
            </>
          ) : !campaignDiscount && !isFreePromo ? (
            <div className='subscrition-card-info-price-main'>
              ${formatPrice(price / data.month_count)}{' '}
              <span className='subscrition-card-info-price-sub'>
                / {t('monthShort')}
              </span>
            </div>
          ) : isFreePromo ? (
            <div className='subscrition-card-info-price-main subscrition-card-info-price-main-campaign'>
              {formatSubscriptionText({
                months: 0,
                days: campaign?.duration,
                price: data.price,
                month_count: data.month_count,
                t: (key) =>
                  key === 'monthShort' ? 'mo' : key,
              })}
            </div>
          ) : (
            <div className='subscrition-card-info-price-main subscrition-card-info-price-main-campaign'>
              First month ${formatPrice(price)},<br /> then $
              {formatPrice(data.price / data.month_count)}{' '}
              <span className='subscrition-card-info-price-sub'>
                / {t('monthShort')}
              </span>
            </div>
          )}
        </div>

        {notInList && (
          <div className='subscription-details-text'>
            {isFreePromo
              ? 'Start your free trial today!'
              : t('payMonthlyCancelAnyTime')}
          </div>
        )}
      </div>
    </div>
  )
}

export default SubscriptionCard